import { graphql } from "@cappelendamm/crystallize-types/core/gql";
export const GetCustomerByExternalReference = graphql(`
  query getCustomerByExternalReference($value: String!, $key: String!) {
    customer(externalReference: { key: $key, value: $value }) {
      __typename
      ... on Customer {
        type
        createdAt
        identifier
        firstName
        lastName
        companyName
        birthDate
        phone
        email
        addresses {
          type
          firstName
          lastName
          street
          postalCode
          city
          country
          email
          phone
          meta {
            key
            value
          }
        }
        externalReferences {
          key
          value
        }
        meta {
          key
          value
        }
      }
      ... on UnknownError {
        errorName
        message
      }
    }
  }
`);
